import { BaseModel } from "model/BaseModel";

export default class ViagemTipoDespesa implements BaseModel {
    id: number | null;
    codigo: string | null;
    nome: string;
    valorAlerta: number | null;

    constructor(
        id = null,
        codigo = null,
        nome = '',
        valorAlerta = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.valorAlerta = valorAlerta;
    }

}